import dayjs, { Dayjs } from "utils/dayjs-config";
import { DATE_FORMAT_YYYYMMDD } from "utils/dateutils";

const isCalendarDateString = (date: string) => /^\d{4}-\d{2}-\d{2}$/.test(date);

export function toProjectCalendarPickerValue(
  date: string | null | undefined,
  timezoneId: string
): Dayjs | null {
  if (!date) return null;
  return dayjs.tz(date, DATE_FORMAT_YYYYMMDD, timezoneId);
}

export function fromProjectCalendarPickerValue(
  date: Dayjs,
  timezoneId: string
): string {
  return dayjs
    .tz(date.format(DATE_FORMAT_YYYYMMDD), DATE_FORMAT_YYYYMMDD, timezoneId)
    .format(DATE_FORMAT_YYYYMMDD);
}

export function pickerDayInProjectTimezone(
  date: Dayjs,
  timezoneId: string
): Dayjs {
  return dayjs.tz(
    date.format(DATE_FORMAT_YYYYMMDD),
    DATE_FORMAT_YYYYMMDD,
    timezoneId
  );
}

export function storedDateInProjectTimezone(
  date: string | null | undefined,
  timezoneId: string
): Dayjs | null {
  if (!date) return null;
  return dayjs.tz(date, DATE_FORMAT_YYYYMMDD, timezoneId);
}

export function todayInProjectTimezone(timezoneId: string): Dayjs {
  return dayjs().tz(timezoneId);
}

export function toProjectCalendarDateString(
  date: string | null | undefined,
  timezoneId: string
): string {
  if (!date) return "";
  if (isCalendarDateString(date)) {
    return dayjs
      .tz(date, DATE_FORMAT_YYYYMMDD, timezoneId)
      .format(DATE_FORMAT_YYYYMMDD);
  }
  return dayjs(date).tz(timezoneId).format(DATE_FORMAT_YYYYMMDD);
}
